<!-- 企业级-业务领域-支付记录 -->
<template>
  <div class="mainArea CTPaymentLog">
    <div class="searchDiv mt20">
      <div>
        <div class="dib">
          <el-input
            placeholder="请输入订单号"
            v-model="keyword.order_id"
            clearable
            @keyup.enter.native="getWarehouse(1)"
          ></el-input>
        </div>
        <div class="dib">
          <el-input
            placeholder="请输入设备ID"
            v-model="keyword.device_id"
            clearable
            @keyup.enter.native="getWarehouse(1)"
          ></el-input>
        </div>
        <div class="dib">
          <el-input
            placeholder="请输入操作人姓名、手机号码"
            v-model="keyword.phone"
            clearable
            @keyup.enter.native="getWarehouse(1)"
          ></el-input>
        </div>
        <el-select v-model="keyword.order_status" clearable placeholder="请选择状态">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
      </div>
    </div>
    <div class="tabList">
      <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
        <!-- <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.orderPayList" style="width:100%;">
                <el-table-column type="index" label="序号" width="100"></el-table-column>
                <el-table-column prop="pay_amount" label="支付费用"></el-table-column>
                <el-table-column prop="pay_time" label="支付时间"></el-table-column>
              </el-table>
            </template>
          </el-table-column> -->
        <el-table-column
          fixed
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column
          fixed
          prop="order_sn"
          label="订单号"
          sortable
          width="150"
        ></el-table-column>
        <el-table-column
          prop="user_name"
          label="操作人姓名"
          sortable
          width="120"
        ></el-table-column>
        <el-table-column
          prop="phone_no"
          label="操作人手机号码"
          sortable
          width="150"
        ></el-table-column>
        <el-table-column
          prop="device_type"
          label="设备类型"
          sortable
          width="120"
        ></el-table-column>
        <el-table-column
          prop="device_no_id"
          label="设备ID"
          sortable
          width="150"
        ></el-table-column>
        <el-table-column
          prop="device_name"
          label="设备名称"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="create_time"
          label="时间"
          sortable
          width="200"
        ></el-table-column>
        <el-table-column
          fixed="right"
          prop="use"
          label="总用时长/次数"
          sortable
          width="150"
        ></el-table-column>
        <el-table-column fixed="right" label="总费用" width="100">
          <template slot-scope="scope">￥{{ scope.row.total_amount }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="状态"
          sortable
          prop="status"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == '1'" style="color:#E6A23C"
              >已支付</span
            >
            <span v-if="scope.row.status == '0'" style="color:#409EFF"
              >待支付</span
            >
            <span v-if="scope.row.status == '-1'" style="color:#F56C6C"
              >已取消</span
            >
            <span v-if="scope.row.status == '2'" style="color:#67C23A"
              >已完成</span
            >
          </template> </el-table-column
        >
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="openLog(scope.$index)"
              >开门记录</el-button
            >
            <el-button
              type="text"
              @click="relPayment(scope.row.order_sn)"
              v-if="scope.row.status == '1'"
              >释放订单</el-button
            >
            <el-button
              type="text"
              @click="relPayment(scope.row.order_sn)"
              v-else
              disabled=""
              >释放订单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging" v-if="total > page">
      <el-pagination
        @current-change="currentChange"
        :current-page.sync="curr"
        @size-change="sizeChange"
        :page-size="page"
        :page-sizes="[10, 50, 100, 1000]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog title="提示" :visible.sync="relIndent" width="30%">
      <span>确认要释放订单？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="relIndent = false">取 消</el-button>
        <el-button type="primary" @click="relIndentOrder">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="开门记录" width="600px" :visible.sync="openLogDio">
      <div class="contDio">
        <div class="item_dio">
          <span>操作人：{{ openInfo.user_name }}</span
          ><span>手机号码：{{ openInfo.phone_no }}</span>
        </div>
        <div class="item_dio">
          <span>设备ID：{{ openInfo.device_no_id }}</span>
          <span>设备类型：{{ openInfo.device_type }}</span>
          <span>设备名称：{{ openInfo.device_name }}</span>
        </div>
        <el-table :data="openList">
          <el-table-column
            type="index"
            width="100"
            label="序号"
          ></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == '1'">开门成功</span>
              <span v-if="scope.row.status == '-1'">开门失败</span>
              <span v-if="scope.row.status == '-2'">开门超时</span>
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="open_time"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CBreadCrumb from "../Layout/CBreadCrumb.vue";
import {
  showToast,
  updataBreadCrumb
} from "../../../../static/js/utility/utility.js";
import { bussinessApi, userApi } from "../../../../static/js/api.js";

export default {
  name: "CTPaymentLog",
  components: {
    CBreadCrumb
  },
  data() {
    return {
      options: [
        {
          value: "finish",
          label: "已完成"
        },
        {
          value: "paid",
          label: "已支付"
        },
        {
          value: "unpaid",
          label: "待支付"
        },
        {
          value: "cancel",
          label: "已取消"
        },
        {
          value: "fail",
          label: "已失效"
        }
      ],
      value: "",

      relIndent: false,

      keyword: {
        order_id: "",
        device_id: "",
        phone: "",
        order_status: "",
      },

      configList: [], //审核记录列表
      tableLoading: false,
      //分页
      curr: 1, //当前页
      page: 10, //显示个数
      total: 0, //总数据

      openList: [],
      openInfo: {
        user_name: "", //操作人
        phone_no: "", //手机号
        device_no_id: "", //设备id
        device_type: "", //设备类型
        device_name: "" //设备名称
      },
      openLogDio: false,
      relform: {
        order_id: ""
      }
    };
  },
  mounted() {},
  created: async function() {
    this.getWarehouse();
  },

  methods: {
    //查看开门记录
    async openLog(index) {
      let that = this;
      this.openInfo = {
        user_name: that.configList[index].user_name,
        phone_no: that.configList[index].phone_no,
        device_no_id: that.configList[index].device_no_id,
        device_type: that.configList[index].device_type,
        device_name: that.configList[index].device_name
      };
      const data = {
        order_sn: that.configList[index].order_sn
      };
      const res = await bussinessApi.smzforderOpenList(data);
      if (res.meta.code == 200) {
        that.openList = res.data.list;
        that.openLogDio = true;
      } else {
        showToast(res.meta.message);
      }
    },

    //释放订单
    relPayment(order_id) {
      this.relIndent = true;
      this.relform.order_id = order_id;
    },

    //确认释放订单
    async relIndentOrder() {
      let that = this;
      const data = {
        order_sn: this.relform.order_id
      };
      const res = await bussinessApi.relIndent(data);
      if (res.meta.code == 200) {
        that.relIndent = false;
        that.getWarehouse();
        showToast("释放成功！");
      } else {
        showToast(res.meta.message);
      }
    },

    //获取快递员列表
    async getWarehouse(curr, limits) {
      let that = this;
      this.tableLoading = true;
      const data = {
        page: curr ? curr : that.curr, //当前页
        perPage: limits ? limits : that.page, //每页条数
        device_no_id: that.keyword.device_id,
        order_sn: that.keyword.order_id,
        user_info: that.keyword.phone,
        order_status: that.keyword.order_status,
      };
      let res = await bussinessApi.smzfPayList(data);
      if (res.meta.code == 200) {
        that.configList = res.data.list;
        that.total = parseInt(res.data.total);
        that.tableLoading = false;
      } else {
        that.tableLoading = false;
        showToast(res.meta.message);
      }
    },

    //分页
    currentChange(val) {
      this.curr = val;
      // console.log(`当前页: ${val}`);
      this.getWarehouse(val);
    },

    sizeChange(val) {
      console.log("val", val);
      this.page = val;
      this.getWarehouse(1);
    },

    onSearch() {
      this.curr = 1;
      this.getWarehouse();
    }

  },

  watch: {
    // 监听vuex的值变化
    "$store.state.buildingID": async function(newVal, oldVal) {
      this.buildingID = newVal;
    },

    "keyword.device_id": function(newVal, oldVal) {
      if (newVal === '') {
        this.onSearch();
      }
    },

    "keyword.order_id": function(newVal, oldVal) {
      if (newVal === '') {
        this.onSearch();
      }
    },

    "keyword.phone": function(newVal, oldVal) {
      if (newVal === '') {
        this.onSearch();
      }
    },

    "keyword.order_status": function(newVal, oldVal) {
      if (newVal === '') {
        this.onSearch();
      }
    },
    /*
    keyword: {
        handler: function(newVal, oldVal) {
          console.log('newVal', newVal);
          console.log('oldVal', oldVal);
          let isChanged = false;
          for(let key in newVal) {
            if (newVal[key] === '') {
              isChanged = true;
            }
          }
          
          if (isChanged) {
            this.onSearch();
          }
        },
        deep: true,
    }
    */
  }
};
</script>

<style lang="scss">
.CTPaymentLog {
  .el-table__expanded-cell {
    padding: 0;
  }
  .fs25 {
    font-size: 25px;
  }
  .flexItem {
    flex-grow: 1;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .previewDio {
    .tr {
      text-align: right;
      el-button {
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img {
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img {
        width: 100%;
      }
    }
  }

  .dib {
    display: inline-block;
  }
  .db {
    display: block;
  }
  .contDio {
    .item_dio {
      line-height: 34px;
      span {
        margin-right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CTactics/CTPaymentLog.vue